import { useState } from 'react';
import Reveal from './Reveal';

export default function SubscribeNotice() {
  const [contact, setContact] = useState('');
  const [state, setState] = useState<'idle' | 'done' | 'empty'>('idle');

  const handleClick = () => {
    if (!contact.trim()) {
      setState('empty');
      return;
    }
    setState('done');
  };

  return (
    <section id="subscribe" className="bg-primary-500">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <span className="font-label text-xs font-medium tracking-[0.25em] text-primary-100">
                NEXT TEASER ALERT
              </span>
              <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
                订阅下期预告提醒
              </h2>
              <p className="mt-4 max-w-xl font-body text-sm leading-relaxed text-primary-50 md:text-base">
                留下一个联系方式，下期爆料上线时先收到风声。我们只发预告，不发无关打扰。
              </p>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-lg border border-primary-400/60 bg-primary-600/40 p-5 md:p-6">
                <label
                  htmlFor="teaser-contact"
                  className="font-label text-xs text-primary-100"
                >
                  邮箱或手机号
                </label>
                <div className="mt-2 flex flex-col gap-3 sm:flex-row">
                  <input
                    id="teaser-contact"
                    name="teaser_contact"
                    type="text"
                    value={contact}
                    onChange={(event) => {
                      setContact(event.target.value);
                      if (state !== 'idle') {
                        setState('idle');
                      }
                    }}
                    placeholder="例如：you@example.com"
                    className="w-full rounded-md border border-primary-300/70 bg-background-50 px-4 py-3 font-body text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-accent-500 focus:outline-none"
                  />
                  <button
                    type="button"
                    onClick={handleClick}
                    className="inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 font-label text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-notification-3-line" />
                    </span>
                    订阅
                  </button>
                </div>

                <div className="mt-3 min-h-[20px]">
                  {state === 'done' && (
                    <p className="flex items-center gap-1.5 font-label text-xs text-background-50">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-checkbox-circle-line" />
                      </span>
                      已记录，下期预告上线时提醒你（演示展示，不会真实发送）。
                    </p>
                  )}
                  {state === 'empty' && (
                    <p className="flex items-center gap-1.5 font-label text-xs text-accent-200">
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-error-warning-line" />
                      </span>
                      请先填写一个联系方式。
                    </p>
                  )}
                  {state === 'idle' && (
                    <p className="font-label text-xs text-primary-100">
                      仅用于预告提醒，可随时取消。
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}